export const FeatureItems = {
    AGENT: "agent",
    ARCHIVE: "archive",
    CHAT: "chat",
    CHATBOT: "chatbot",
    REPORT: "report",
    SUPPORT: "support",
    SYSTEM: "system",
    TRIGGERS: "trigger",
    WHATSAPP: "whatsapp",
    TEAM_CHAT: "teamChat",
    MAIL: "mail",
    SMS: "sms",
    INSTAGRAM: "instagram",
    MESSENGER: "messenger",
    SERVICES: "services",
    TRENDYOL: "trendyol",
    FORM: "form",
    AUTOMATION: "automation",
    META_LEAD: "meta-lead",
    CUSTOMER_TABLES: "customer-tables",
    TASK: "task",
    LINKEDIN: "linkedin",
    TELEGRAM: "telegram",
    WEB_TRAFFIC: "web-traffic",
    VOICE_AGENT: "voice-agent",
};

/**
 * TODO: Her bir paket için ayrı ayrı özellikler tanımlamak
 * TODO: yerine genel olarak bir özelliğimiz olur, packageType_feature şeklinde birleştirebiliriz böylecek her
 * TODO: paket için bir feature ekleme gibi işleme gerek duymayız
 * TODO: Örnek; intagramChannelCount gibi eklemeler yapmak yerine, channelCount ekleriz sadece ve paket tipine göre
 * TODO: bu özelliklerin değerlerini alırız. instagram_channelCount, whatsapp_channelCount gibi
 * TODO: trendyol_chatbotManage gibi eklemeler yerine chatbotManage ekleriz ve paket tipine göre trendyol_chatbotManage gibi alırız
 **/

export const Features = {
    AGENT: {
        FREE_AGENT_COUNT: "freeAgentCount", // ✅
        AGENT_COUNT: "agentCount", // ✅
    },
    ARCHIVE: {
        MAX_CHAT_ARCHIVE_TIME: "maxChatArchiveTime",
        CHAT_ARCHIVE_TIME: "chatArchiveTime",
    },
    CHAT: {
        AUTO_TRANSLATION: "autoTranslation", // ✅
        VOICE_CALLING: "voiceCalling", // ✅
        VIDEO_CALLING: "videoCalling", // ✅
        FILE_AND_VOICE_MESSAGE: "fileAndVoiceMessage", // ✅
        COPILOT: "chatCopilot", // ✅
        LIVE_CHAT: "liveChat",
        LIVE_SCORE: "liveScore",
        MULTIPLE_CHAT_WINDOW: "multipleChatWindow",
        SHARE_SCREEN: "shareScreen",
    },
    CHATBOT: {
        MAX_SESSION_COUNT: "maxSessionCount", // ✅
        STORY_COUNT_LIMIT: "storyCountLimit",
        INTEGRATION_COUNT: "integrationCount",
        VERSION_HISTORY_COUNT: "versionHistoryCount",
        CHATBOT_BUTTON_ACTIVITY: "chatbotButtonActivity",
        ACTIVE_CHATBOT_LIMIT: "activeChatbotLimit",
    },
    REPORT: {
        REPORT: "report",
        VISITOR_TRACKING: "visitorTracking",
        SPECIAL_REPORT: "specialReport",
    },
    SUPPORT: {
        SUPPORT: "support",
        SOFTWARE_SUPPORT: "softwareSupport",
        DEDICATED_CUSTOMER_SUPPORT: "dedicatedCustomerSupport",
        WHATSAPP_BUSINESS_SETUP: "supportWhatsappBusinessSetup",
        FACEBOOK_SETUP: "supportFacebookSetup",
        INSTAGRAM_SETUP: "supportInstagramSetup",
        CHATBOT_SETUP: "supportChatbotSetup",
        AI_SETUP: "supportAISetup",
        AUTOMATION_SETUP: "supportAutomationSetup",
        SPECIAL_PANEL_TRAINING: "supportSpecialPanelTraining",
        CONSULTANCY: "supportConsultancy",
        INTEGRATION_SETUP: "supportIntegrationSetup",
        STRATEGY_PLANNING: "supportStrategyPlanning",
    },
    SYSTEM: {
        TICKET_RECEIVING_LIMIT: "ticketReceivingLimit",
        READY_CONTENTS_LIMIT: "readyContentsLimit",
        READY_CONTENTS_IMAGE_LIMIT: "readyContentsImage",
        DEPARTMENT_LIMIT: "departmentLimit",
        ROLE_LIMIT: "roleLimit",
        CRM_CONTACT_LIMIT: "crmContactLimit",
        CHAT_AND_NOTIFICATION: "chatAndNotification",
        CHAT_BALLOON_CUSTOMIZATION: "chatBalloonCustomization",
        REMOVE_SUPSIS_LOGO: "removeSupsisLogo", // ✅
        DATABASE_CONNECTION: "databaseConnection",
        ACCESS_CONTROL: "accessControl",
        SINGLE_PANEL_ACCESS: "singlePanelAccess",
        TICKET_SYSTEM: "ticketSystem", // ✅
        CHATBOT_ENTEGRATION: "chatbotEntegration", // ✅
        TEAM_CHAT_ENTEGRATION: "teamChatEntegration", // ✅
        WHATSAPP_ENTEGRATION: "whatsappEntegration", // ✅
        INSTAGRAM_ENTEGRATION: "instagramEntegration", // ✅
        MESSENGER_ENTEGRATION: "messengerEntegration", // ✅
        MAIL_ENTEGRATION: "mailEntegration", // ✅
        SMS_ENTEGRATION: "smsEntegration", // ✅
        WEBHOOK_ENTEGRATION: "webhookEntegration", // ✅
        CALENDER_ENTEGRATION: "calenderEntegration", // ✅
        TASK_MANAGEMENT_ENTEGRATION: "taskManagementEntegration", // ✅
        CALENDAR_WEB_FEATURE: "calendarWebFeature",
        ALL_ENTEGRATION: "allEntegrations", // ✅
        ACCESS_ALL_AGENT: "accessAllAgent",
        VISITOR_START_CHAT: "visitorStartChat", // ✅
        DATA_PROTECT: "dataProtect",
        READY_CONTENTS: "readyContents", // ✅
        PERMISSION_CONTROL: "permissionControl",
        AUTO_REZERVATION: "autoRezervation",
        FLEXIBLE_BILLING: "flexibleBilling",
        MAX_DISK_SIZE: "maxDiskSize",
        FREE_AI_TOKEN: "freeAIToken",
    },
    TRIGGERS: {
        MAX_TRIGGER_COUNT: "maxTriggerCount", // ✅
    },
    WHATSAPP: {
        CHANNEL_COUNT: "channelCount", // ✅
        BUSINESS_CHANNEL_COUNT: "businessChannelCount", // ✅
        BROADCAST_PER_MESSAGE: "broadcastPerMessage",
        BULK_MESSAGE_SENDING: "bulkMessageSending",
        MESSAGE_UNREGISTERED_NUMBERS: "messageUnregisteredNumbers",
        PERSONALIZED_BROADCAST_MESSAGE: "personalizedBroadcastMessage",
        CONTROL_WHATSAPP: "controlWhatsapp",
        WHATSAPP_CHATBOT_ENTEGRATION: "whatsappChatbotEntegration",
        NOT_ADDITIONAL_PRICE: "notAdditionalPrice",
    },
    TEAM_CHAT: {},
    SMS: {},
    INSTAGRAM: {
        CHANNEL_COUNT: "instagramChannelCount", // ✅
        MANAGE_INBOX: "instagramManageInbox",
        COMMENT_MANAGEMENT: "instagramCommentManagement",
        PRIVATE_REPLY_MESSAGE: "instagramPrivateReplyMessage",
        MENTION_TICKET: "instagramMentionTicket",
        MANAGE_WITH_CHATBOT: "instagramManageWithChatbot",
    },
    MESSENGER: {
        CHANNEL_COUNT: "messengerChannelCount", // ✅
    },
    TRENDYOL: {
        ENTEGRATION: "trendyolEntegration", // ✅
        CHANNEL_COUNT: "trendyolChannelCount", //✅
        QUESTION_ANSWER: "trendyolQuestionAnswer", // ✅
        AUTOMATIC_ANSWER: "trendyolAutomaticAnswer", // ✅
        COMMENT_CHATBOT_MANAGE: "trendyolCommentChatbotManage", // ✅
    },
    META_LEAD: {
        CHANNEL_COUNT: "metaLeadChannelCount",
        AUTOMATION_MANAGE: "metaLeadAutomationManage",
        TICKET_MANAGE: "metaLeadTicketManage",
    },
    AUTOMATION: {
        ENTEGRATION: "automationEntegration",
        LIMIT: "automationLimit",
        TASK_FREE_LIMIT: "automationTaskFreeLimit", // Ücretsiz tanımlanan hak
        EVENT_BASE: "automationEventBase",
        WEBHOOK_BASE: "automationWebhookBase",
        BUTTON_BASE: "automationButtonBase",
        TIMER_BASE: "automationTimerBase",
        BLOCK: "automationBlock",
    },
    FORM: {
        ENTEGRATION: "formEntegration",
        LIMIT: "formLimit",
        SUBMIT_LIMIT: "formSubmitLimit",
        VIEW_LIMIT: "formViewLimit",
        FIELD_LIMIT: "formFieldLimit",
    },
    MAIL: {
        FREE_COUNT: "mailFreeCount",
        COUNT: "mailCount",
        PER_COUNT: "mailPerCount",
        PER_PRICE: "mailPerPrice",
        DETAIL_BROADCAST_REPORT: "detailedBroadcastReport",
    },
    CUSTOMER_TABLES: {
        ENTEGRATION: "customerTablesEntegration",
        AI_FEATURE: "customerTableAIFeature",
        LINKED_FEATURE: "customerTableLinkedFeature",
        COUNT: "customerTableCount",
        FIELD_COUNT: "customerTableFieldCount",
        RECORD_COUNT: "customerTableRecordCount",
        VIEW_COUNT: "customerTableViewCount",
    },
    TASK: {
        WORKFLOW_LIMIT: "taskWorkflowLimit",
        COLUMN_LIMIT: "taskColumnLimit",
        ROW_LIMIT: "taskRowLimit",
    },
    SERVICES: {
        FLEXIBLE_PRICING: "flexiblePricing",
        UNLIMITED_CB_SCENARIO: "unlimitedCBScenario",
        FREE_FIRST_SCENARIO: "freeFirstScenario",
        RIGHT_TO_CANCEL: "rightToCancel",
        UNLIMITED_LEARN: "unlimitedLearn",
        ALL_PLATFORM_INTEGRATION: "allPlatformIntegration",
        AI_SUPPORT: "aiSupport",
        CREATIVE_AI: "creativeAI",
        UNLIMITED_SESSION: "unlimitedSession",
        ASSISTANT_FROM_WEB: "assistantFromWebsite",
        ASSISTANT_FROM_DOC: "assistantFromDoc",
        MOBILE_APP: "mobileApp",
        WHATSAPP: "whatsapp",
        EMAIL: "email",
        WEB: "web",
        INSTAGRAM: "instagram",
        MESSENGER: "messenger",
        API_USAGE: "apiUsage",
        EXCEL_DOWNLOAD: "excelDownload",
        CUSTOMER_GROUP: "customerGroup",
        MANAGE_INBOX: "manageInbox",
        COMMENT_MANAGEMENT: "commentManagement",
        PRIVATE_REPLY_MESSAGE: "privateReplyMessage",
        MENTION_TICKET: "mentionTicket",
        MANAGE_WITH_CHATBOT: "manageWithChatbot",
    },
    LINKEDIN: {
        CHANNEL_COUNT: "linkedinChannelCount",
        ENTEGRATION: "linkedinEntegration",
    },
    TELEGRAM: {
        CHANNEL_COUNT: "telegramChannelCount",
        ENTEGRATION: "telegramEntegration",
    },
    WEB_TRAFFIC: {
        ENABLED: "webTrafficEnabled",
        ANALYTICS: "webTrafficAnalytics",
    },
    VOICE_AGENT: {
        ACTIVE_AGENT_COUNT: "voiceAgentActiveCount",
        APPOINTMENT_TRACKING: "voiceAgentAppointmentTracking",
        BULK_CALL_COUNT: "voiceAgentBulkCallCount",
        VOICE_CLONING: "voiceAgentVoiceCloning",
        READY_VOICE_OPENAI: "voiceAgentReadyVoiceOpenAI",
        COMMUNITY_VOICE: "voiceAgentCommunityVoice",
        CONCURRENT_CALL_COUNT: "voiceAgentConcurrentCallCount",
        WEB_AGENT: "voiceAgentWebAgent",
        CHATBOT_CALL: "voiceAgentChatbotCall",
        AUTOMATION_CALL: "voiceAgentAutomationCall",
        TABLE_CALL: "voiceAgentTableCall",
        CONTACT_CALL: "voiceAgentContactCall",
        LLM_SUPPORT: "voiceAgentLlmSupport",
        CUSTOM_LLM_INTEGRATION: "voiceAgentCustomLlmIntegration",
        CUSTOM_DATA_TRAINING: "voiceAgentCustomDataTraining",
        IVR: "voiceAgentIvr",
        CUSTOM_FUNCTIONS: "voiceAgentCustomFunctions",
        SENTIMENT_ANALYSIS: "voiceAgentSentimentAnalysis",
        ADVANCED_VOICE_SETTINGS: "voiceAgentAdvancedVoiceSettings",
        SECRETARY_DETECTION: "voiceAgentSecretaryDetection",
        CUSTOM_PROMPTS: "voiceAgentCustomPrompts"
    }
};
